export const MODULE_NAME = 'RESERVATION_MODULE';
